export default __webpack_public_path__ + "static/media/talabalarning_bilimini_baholash_tartibi.0edc8a2d.pdf";